import React, { PureComponent, Fragment } from 'react'
import moment from 'moment'
import cx from 'classnames'

import { Grid, Cell } from 'components/layout/grid'
import Button from 'components/ui/Button/Button'
import Box from 'components/layout/Box/Box'


class SubscribersReport extends PureComponent {

  state = {
    node: null,
  }

  componentDidMount() {
    const encodedUri  = this.getEncodeUri()
    const link        = document.createElement('a')

    link.setAttribute('href', encodedUri)
    link.setAttribute('download', `${this.getTitle()}.csv`)

    document.body.appendChild(link)

    this.setState({ node: link })
  }

  componentWillUnmount() {
    const { node } = this.state

    document.body.removeChild(node)
  }

  getTitle = () => {
    const { from, to } = this.props

    const date = `с ${moment(from, 'DDMMYYYY').format('DD.MM.YYYY')} по ${moment(to, 'DDMMYYYY').format('DD.MM.YYYY')}`

    return `Отчет: Статистика ${date}`
  }

  getEncodeUri = () => {
    const { statistic } = this.props

    let encodeData = 'data:text/csv;charset=utf-8,\uFEFF'

    const rows = []

    rows.push([ this.getTitle() ])

    Object.keys(statistic).map((key) => {
      const { items, total, title } = statistic[key]

      rows.push([ `Тип данных статистики: ${title}`, `Количество: ${total}` ])
      rows.push([ ' ', 'Количество', 'Процент' ])

      items.forEach(({ statName, count, percent }) => {
        rows.push([ statName, count, Number(percent).toFixed(2) ])
      })
    })

    return `${encodeData}${
      rows.map((items) => (
        items.map((item) => String(item || '')).join(';')
      ))
        .join('\n')
      }`
  }

  handleButtonClick = () => {
    const { node } = this.state
    const { onClose } = this.props

    node.click()
    onClose()
  }

  render() {
    const {
      titleClassName, darkestClassName, darkClassName, buttonClassName,
      statistic, isEmpty,
    } = this.props

    return (
      <Fragment>
        <Box pb="md">
          <div className={titleClassName}>{this.getTitle()}</div>
        </Box>
        {
          isEmpty ? (
            <div>Нет статистики по выбранным условиям</div>
          ) : (
            <Fragment>
              {
                statistic.subscribers.map(({ items, total, title }) => (
                  <Fragment key={key}>
                    <Grid className={darkestClassName} columns={3} gutter="md">
                      <Cell size={3}>
                        Тип данных статистики: {title}
                      </Cell>
                      <Cell size={3}>
                        Количество: {total}
                      </Cell>
                    </Grid>
                    {
                      items.map(({ statName, count, percent }, index) => (
                        <Fragment key={index}>
                          {
                            Boolean(!index) && (
                              <Grid columns={3} gutter="md">
                                <Cell size={1} />
                                <Cell size={1}>
                                  Количество
                                </Cell>
                                <Cell size={1}>
                                  Процент
                                </Cell>
                              </Grid>
                            )
                          }
                          <Grid className={cx({ [darkClassName]: index % 2 !== 0 })} columns={3} gutter="md">
                            <Cell size={1}>
                              {statName}
                            </Cell>
                            <Cell size={1}>
                              {count}
                            </Cell>
                            <Cell size={1}>
                              {Number(percent).toFixed(2)}
                            </Cell>
                          </Grid>
                        </Fragment>
                      ))
                    }
                  </Fragment>
                ))
              }
              <Box pt="md">
                <Button
                  className={buttonClassName}
                  title="Сохранить в файл"
                  green
                  onClick={this.handleButtonClick}
                />
              </Box>
            </Fragment>
          )
        }
      </Fragment>
    )
  }
}


export default SubscribersReport
